import { render, staticRenderFns } from "./order-confirmation-template-selection.vue?vue&type=template&id=543222b7&scoped=true&"
import script from "./order-confirmation-template-selection.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-template-selection.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-template-selection.vue?vue&type=style&index=0&id=543222b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543222b7",
  null
  
)

export default component.exports